// Shared engine for the "generate token / workstation link" modal buttons:
// POST the clicked button's data-url (JSON, /account/api_tokens) with a scope
// preset, then hand the one-time payload to onSuccess. The secret is never
// retrievable again, so failures re-enable the button with the error inline.
import { csrfToken } from "../../util/methods"

export function requestApiToken(event, options) {
  event.preventDefault()
  var $btn = $(event.currentTarget)
  var $modal = $btn.closest(".modal")
  var $error = $modal.find(options.errorSelector)

  $btn.prop("disabled", true)
  $error.addClass("d-none")

  fetch($btn.data("url"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: JSON.stringify({
      api_token: { name: options.tokenName($modal) },
      scope_preset: options.scopePreset,
    }),
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.error || options.failureMessage)
        return data
      })
    })
    .then(function (data) {
      options.onSuccess($modal, data)
    })
    .catch(function (error) {
      $btn.prop("disabled", false)
      $error.text(error.message).removeClass("d-none")
    })
}

export function defaultTokenName() {
  return "Blender – " + new Date().toISOString().slice(0, 10)
}
